// Overdrawn Cash: Desk alerts. The Desk side of `wealth.ops.overdrawn-cash`
// (ADR-0027): the overdrawn accounts of the book of the IM and the accounts on
// the Desk worklist.
import type { OverdrawnCashResponse } from '@septima/contract';
import { defineWebFeature } from '@/features/kit';
import { deskOverdrawnCashQuery } from '@/lib/cash/use-desk-overdrawn';
import { overdrawnItems } from '@/pages/desk/actions/worklist';

export default defineWebFeature({
    id: 'wealth.ops.overdrawn-cash.desk-alerts',
    routes: [
        {
            frontend: 'desk',
            path: 'cash/overdrawn',
            lazy: () => import('@/pages/desk/cash/overdrawn/page'),
        },
    ],
    nav: [
        {
            frontend: 'desk',
            key: 'overdrawn-cash',
            label: 'Overdrawn Cash',
            href: '/desk/cash/overdrawn',
            icon: 'AlertTriangle',
            group: 'tasks-alerts',
            order: 330,
        },
    ],
    slots: {
        'desk.worklist.sources': [
            {
                key: 'overdrawn-cash',
                order: 10,
                query: () => deskOverdrawnCashQuery(),
                select: (input) => ({
                    items: overdrawnItems((input as OverdrawnCashResponse | undefined)?.rows ?? []),
                    tile: {
                        label: 'Overdrawn Accounts',
                        severity: 'red',
                        to: '/desk/cash/overdrawn',
                        ariaLabel: 'Overdrawn Accounts: open the list',
                    },
                }),
            },
        ],
    },
});
